export const MIN_DATE = new Date('2008-01-01T00:00:00.000Z');
